import React from 'react';
import { Twitter, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="relative bg-[#ffd54f] overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -left-10 bottom-0 w-72 h-72 bg-[#b3ebf2]/30 rounded-full blur-3xl" />
        <div className="absolute right-0 top-0 w-72 h-72 bg-white/20 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 py-8">
        {/* Main footer content */}
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
          {/* Logo */}
          <div className="flex items-center space-x-4">
          <Link to="/" className="transition-opacity hover:opacity-80">
              <img 
                src="/groviyo.png"
                alt="Groviyo" 
                className="h-20 w-auto sm:h-24"
              />
            </Link>
          </div>

          {/* Locations */}
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-sm">
            {[
              'Virginia',
              'DC',
              'Maryland',
              'New York',
              'California',
              'Texas'
            ].map((location) => (
              <span 
                key={location}
                className="text-gray-800 hover:text-[#b3ebf2] transition-colors duration-300"
              >
                {location}
              </span>
            ))}
          </div>

          {/* Social Links */}
          <div className="flex space-x-3">
            <a 
              href="#twitter" 
              className="group"
              aria-label="Twitter"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/50 hover:bg-[#b3ebf2] transition-colors duration-300">
                <Twitter className="w-4 h-4 text-gray-800 group-hover:text-gray-800" />
              </div>
            </a>
            <a 
              href="#instagram" 
              className="group"
              aria-label="Instagram"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/50 hover:bg-[#b3ebf2] transition-colors duration-300">
                <Instagram className="w-4 h-4 text-gray-800 group-hover:text-gray-800" />
              </div>
            </a>
          </div>
        </div>

        {/* Bottom info */}
        <div className="mt-6 pt-6 border-t border-gray-800/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-800 text-sm">
              PO Box 1633, Va. Beach VA, 23451
            </p>
            <p className="text-gray-800 text-sm">
              © 2024 NeoOut Interactive, All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;